<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="row justify-content-center mb-4">
          <img src="@/assets/images/nodejs.png" width="20%" alt="" />
        </div>
        <div class="row justify-content-center">
          <h1>O que é?</h1>
        </div>
        <p class="lead">
          O Node.js NÃO é um framework! O Node é um javascript environment ou um
          ambiente para a compilação e execução do código escrito em javascript.
          O Node.js é semelhante em design e influenciado por sistemas como Ruby
          Event Machine e Python's Twisted levando o modelo de evento um pouco
          mais longe.
        </p>

        <div class="row justify-content-center">
          <h1>Por que utilizar?</h1>
        </div>
        <p class="lead">
          Onde o Node realmente brilha é na construção de aplicativos de rede
          rápidos e escaláveis, pois é capaz de lidar com um grande número de
          conexões simultâneas com alto rendimento, o que equivale a alta
          escalabilidade.
        </p>
        <p class="lead">
          Como funciona nos bastidores é muito interessante. Comparado às
          técnicas tradicionais de veiculação da web, em que cada conexão
          (solicitação) gera um novo thread, ocupando a RAM do sistema e,
          eventualmente, maximizando a quantidade de RAM disponível, o Node.js
          opera em um único thread, usando I / sem bloqueio O chamadas,
          permitindo que ele suporte dezenas de milhares de conexões simultâneas
          mantidas no loop de eventos.
        </p>
        <div class="row justify-content-center mb-4">
          <img
            src="https://uploads.toptal.io/blog/image/50/toptal-blog-1_B.png"
            width="600px"
            alt="node-image"
          />
        </div>

        <div class="col-sm-12 mt-5">
          <div class="row justify-content-center">
            <h1>Onde baixar?</h1>
          </div>
          <p class="lead">
            Você pode realizar o download do Node.js no site oficial ->
            <a target="_blank" href="https://nodejs.org/en/"
              >https://nodejs.org/en/</a
            >. Lá você também pode encontrar tutoriais de aplicações simples,
            integrações de componentes e muito mais.
          </p>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <base-button type="primary" class="my-4" @click="scrollTop"
        >Voltar ao topo</base-button
      >
    </div>
  </div>
</template>

<script>
import { scrollTop } from "@/global";

export default {
  name: "node-article",
  methods: { scrollTop: scrollTop },
};
</script>

<style>
</style>